<template>
<div class="box">

  <div class="mt-0">
    <div class="thead no-border">
      <!--table class="tbl">
        <thead>
          <tr>
            <th>이름</th>
            <th>계통</th>
          </tr>
        </thead>
      </table-->
    </div>
    <!--div class="box-body scrollable" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick'}" style="margin-bottom:20px"-->
    <div class="tbody  box-body scrollable" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick', height: '200px'}" :style="[{'max-height': height + 'px'}, {'height': height + 'px'}, {'overflow-y': 'scroll'}]">
      <table class="tbl">
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td><label class="md-check listItem-ellipsis" style="margin-right:0">
            <input type="checkbox">
            <i class="blue"></i></label>
            <i class="icon-complete" v-if="item.status == 0">&nbsp;</i>
            <i class="icon-fail" v-if="item.status == 1">&nbsp;</i>
            <i class="icon-security" v-if="item.status == 2">&nbsp;</i>
            {{item.path}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['title', 'description', 'isSearch', 'height', 'items'],
}
</script>

<style>

</style>